<template>
  <FlotoDrawerForm
    ref="drawer"
    :open="Boolean(markLeaveDrawerInfo)"
    @cancel="cancelAction"
    @submit="handleAddLeave"
  >
    <template v-slot:header>
      {{ formData.id ? $t('edit_leave') : $t('mark_leave') }}
    </template>
    <MarkLeaveForm
      :form-data="formData"
      :reset-form="resetForm"
      :technician-is-disabled="technicianIsDisabled"
    />
    <template v-slot:actions="{ submit, hide }">
      <MButton class="mx-1" :loading="processing" @click="submit">
        {{ $t('save') }}
      </MButton>
      <MButton variant="default" @click="hide">
        {{ $t('cancel') }}
      </MButton>
    </template>
  </FlotoDrawerForm>
</template>
<script>
import { createUserLeaveApi, updateUserLeaveApi } from '../calendar-api.js'
import MarkLeaveForm from './mark-leave-form'
export default {
  name: 'MarkLeaveDrawer',
  components: { MarkLeaveForm },
  props: {
    markLeaveDrawerInfo: { type: Object, default: undefined },
    technicianIsDisabled: { type: Boolean, default: false },
  },
  data() {
    this.defaultData = {}
    return {
      formData: {
        ...(this.markLeaveDrawerInfo || {}),
      },
      processing: false,
    }
  },
  methods: {
    cancelAction() {
      this.$emit('cancel')
    },

    handleAddLeave() {
      this.processing = true
      const apiFn = this.formData.id ? updateUserLeaveApi : createUserLeaveApi
      return apiFn(this.formData)
        .then(() => {
          this.cancelAction()
          this.$emit('refresh')
        })
        .finally(() => {
          this.processing = false
        })
    },
    resetForm(data) {
      this.formData = {
        ...data,
      }
    },
  },
}
</script>
